import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AufnahmePunktDocument, istPunktartMitProtokoll } from '../../data-model';
import { Command, NavbarService } from 'src/app/navbar.service';
import { AuthService } from 'src/app/auth.service';
import { DataService } from 'src/app/data.service';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-print-view',
    templateUrl: './bohrpunkt-print-view.component.html',
    styleUrls: ['./bohrpunkt-print-view.component.css'],
    
})
export class BohrpunktPrintViewComponent implements OnInit, OnDestroy {
	bp!: AufnahmePunktDocument;

	istPunktartMitProtokoll = istPunktartMitProtokoll;

	private routeSubscription?: Subscription;
	private authChangedSubscription?: Subscription;

	constructor(
		public ds: DataService,
		private aus: AuthService,
		private ns: NavbarService,
		private route: ActivatedRoute,		
		private router: Router,
	) { 
	}
	
	private initButtons() {
		this.ns.subscribe(Command.goBackToPoint, () => this.onClose());
		this.ns.subscribe(Command.print, () => this.onPrint());
	}
	
  ngOnInit() {
		this.routeSubscription = this.route.data.subscribe(data => {
			this.bp = data['bp'];
			// Druckdialog automatisch öffnen nach kurzem Delay (damit Seite gerendert ist)
			setTimeout(() => window.print(), 100);
		});
		this.authChangedSubscription = this.aus.authChanged.subscribe(() => this.initButtons());
		this.initButtons();
  }

	ngOnDestroy(): void {
		this.ns.unsubscribe(Command.goBackToPoint);
		this.ns.unsubscribe(Command.print);
		this.routeSubscription?.unsubscribe();
		this.authChangedSubscription?.unsubscribe();
	}

  onClose() {
    this.router.navigate(['/bohrpunkte', this.bp._id]);
  }

	onPrint() {
		window.print();
	}
}
